import { render } from "./MasterBoardCharts.vue?vue&type=template&id=02b4b868&scoped=true"
import script from "./MasterBoardCharts.vue?vue&type=script&lang=js"
export * from "./MasterBoardCharts.vue?vue&type=script&lang=js"

import "./MasterBoardCharts.vue?vue&type=style&index=0&id=02b4b868&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-02b4b868"

export default script